import React, {useRef, useState} from 'react'
import {SearchOutlined} from '@ant-design/icons';
import {Button, Input, Space, Table, Tag} from 'antd';
import BookNumber from "./BookNumber";
import checkRole from "../../../../../../helpers/checkRole";
import IsolationNumber from "./IsolationNumber";
import TestNumber from "./TestNumber";
import moment from "moment/moment";

function BlockLeft(props) {
    const {listTenantNumber, fetchListTenantNumber, custId, listTelco, shortPhone} = props
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    }

    const resetRowKeys = () => {
        setSelectedRowKeys([])
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, close}) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                text
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: 'Hotline',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            sorter: (a, b) => a.address.length - b.address.length,
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('phoneNumber'),
        },
        {
            title: 'Số ảo',
            dataIndex: 'shortPhone',
            key: 'shortPhone',
            ...getColumnSearchProps('shortPhone'),
        },
        {
            title: 'Mạng',
            dataIndex: 'telco',
            key: 'telco',
            ...getColumnSearchProps('telco'),
        },
        {
            title: 'Source',
            dataIndex: 'source',
            key: 'source',
            ...getColumnSearchProps('source'),
        },
        {
            title: 'Brand name',
            dataIndex: 'brandName',
            key: 'brandName',
            ...getColumnSearchProps('brandName'),
        },
        {
            title: 'Ngày book',
            dataIndex: 'bookedDate',
            key: 'bookedDate',
            ...getColumnSearchProps('bookedDate'),
            render: (text) => {
                return text && moment(text).format('DD/MM/YYYY')
            }
        },
        {
            title: 'Trạng thái chung',
            dataIndex: 'actions',
            key: 'actions',
            ...getColumnSearchProps('strStatus'),
            render: (text, record) => {
                return mapStatus(record.status, record.strStatus)
            }
        },
        {
            title: 'Trạng thái gọi VTL',
            dataIndex: 'statusLockVTL',
            key: 'statusLockVTL',
            ...getColumnSearchProps('statusLockVTL'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockVTL)
            }
        },
        {
            title: 'Trạng thái gọi MBF',
            dataIndex: 'statusLockMBF',
            key: 'statusLockMBF',
            ...getColumnSearchProps('statusLockMBF'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockMBF)
            }
        },
        {
            title: 'Trạng thái gọi VNA',
            dataIndex: 'statusLockVNA',
            key: 'statusLockVNA',
            ...getColumnSearchProps('statusLockVNA'),
            render: (text, record) => {
                return mapStatusLock(record.statusLockVNA)
            }
        },
    ];

    const mapStatusLock = (value) => {
        switch (value) {
            case 'Khóa':
                return <Tag color="#ff0000">{value}</Tag>
            case 'Hoạt động':
                return <Tag color="#108ee9">{value}</Tag>
            default:
                return <Tag color="#000000">{value}</Tag>
        }
    }

    const mapStatus = (value, status) => {
        switch (value) {
            case 0:
                return <Tag color="#531dab">{status}</Tag>
            case 1:
                return <Tag color="#108ee9">{status}</Tag>
            case 2:
                return <Tag color="#2db7f5">{status}</Tag>
            case 3:
                return <Tag color="#f50">{status}</Tag>
            case 8:
                return <Tag color="#9100ff">{status}</Tag>
            case 9:
                return <Tag color="#d4380d">{status}</Tag>
            case -1:
                return <Tag color="#87d068">{status}</Tag>
            default:
                return <Tag color="#000000">{status}</Tag>
        }
    }

    return (
        <div className="BlockLeft tableDauSo">
            <div className="headerBlock d-flex align-items-start justify-content-between">
                <h3> Đầu số</h3>
                <div className="d-flex align-items-center">
                    {
                        checkRole('menu.customerhub.addNumberToTest') &&
                        <TestNumber
                            resetRowKeys={resetRowKeys}
                            selectedRowKeys={listTenantNumber.filter((item, index) => selectedRowKeys.includes(index))}
                            custId={custId}
                            fetchListTenantNumber={fetchListTenantNumber}
                            listTelco={listTelco}
                        />
                    }
                    {
                        checkRole('menu.customerhub.isolationNumber') &&
                        <IsolationNumber
                            custId={custId}
                            fetchListTenantNumber={fetchListTenantNumber}
                            listTelco={listTelco}
                            shortPhone={shortPhone}
                        />
                    }
                    {
                        checkRole('menu.customerhub.bookNumer') &&
                        <BookNumber custId={custId} fetchListTenantNumber={fetchListTenantNumber}/>
                    }
                </div>
            </div>
            <div className="ContentPage">
                <div className="d-flex align-items-center justify-content-between mt-3">
                    <div className="total mb-2">
                        {selectedRowKeys.length > 0 && `${selectedRowKeys.length} selected`}
                    </div>
                    <div className="total mb-2">{listTenantNumber.length} items</div>
                </div>
                <Table
                    rowSelection={{
                        type: "checkbox",
                        ...rowSelection,
                    }}
                    tableLayout="fixed"
                    columns={columns}
                    dataSource={listTenantNumber}
                />
            </div>
        </div>
    )
}

export default BlockLeft
